const TOKEN_KEY = "tea_break_admin_token";
const REMEMBER_KEY = "tea_break_admin_remember";
const USERNAME_KEY = "tea_break_admin_username";
const PASSWORD_KEY = "tea_break_admin_password";

export function getRememberCredentials() {
  if (localStorage.getItem(REMEMBER_KEY) !== "1") {
    return { remember: false, username: "", password: "" };
  }
  return {
    remember: true,
    username: localStorage.getItem(USERNAME_KEY) || "",
    password: localStorage.getItem(PASSWORD_KEY) || "",
  };
}

export function setRememberCredentials({ remember, username, password }) {
  if (remember) {
    localStorage.setItem(REMEMBER_KEY, "1");
    localStorage.setItem(USERNAME_KEY, username || "");
    localStorage.setItem(PASSWORD_KEY, password || "");
  } else {
    localStorage.removeItem(REMEMBER_KEY);
    localStorage.removeItem(USERNAME_KEY);
    localStorage.removeItem(PASSWORD_KEY);
  }
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token || "");
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function isLoggedIn() {
  return !!getToken();
}
